import { useContext } from "react"
import { AtribuirRegiaoContext } from "./AtribuirRegiaoContext"

export function useAtribuirRegiaoContext() {
    return useContext(AtribuirRegiaoContext)
}
